import api from './api';
import types from './mutation-types';
import _ from 'lodash';

export default {
	addExcelUpload_({ commit }, { formData }) {
		return api
			.addExcelUpload({ formData })
			.then(data => {
				if (data.header.code === 0) {
					//원래는 data.header를 넘기는데 이번엔 전체를 넘긴다.
					return data;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async deleteFile_(store, { fileId, fileSeq }) {
		try {
			const data = await api.deleteFile({ fileId, fileSeq });
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	// 유저 정보 object로 반환
	async getUsrFullInfo_({ commit, rootState }) {
		const response = await api.getDeptNm(rootState.commonStore.user?.deptCd);
		const grpInfo = (await api.getUsrGrpInfo()) || [];
		return { ...grpInfo, deptCd: response?.deptCd, deptNm: response?.deptNm };
	},
	// 그룹 정보 array로 반환
	async getUsrGrpInfo_({ dispatch }) {
		const { grpList } = await dispatch('getUsrFullInfo_');
		return grpList?.length && grpList.split('|');
	},
	// 해당 그룹에 사용자가 속하는지 여부를 boolean 값으로 반환
	async inclUsrGrp_({ dispatch }, grpNm) {
		//grpNm : String 예시)) 'OS'
		const grpList = await dispatch('getUsrGrpInfo_');
		return grpList.includes(grpNm);
	},
	// 해당 그룹 여러개 중에 하나라도 사용자가 속하는지 여부를 boolean 값으로 반환
	async inclManyUsrGrp_({ dispatch }, grpNmList) {
		//grpNmList : Array 예시)) ['MMCUR', 'OS']
		const grpList = await dispatch('getUsrGrpInfo_');
		const intersectionArr = _.intersection(grpList, grpNmList);
		return intersectionArr.length > 0;
	},
	//협력업체 여부(String Y, N) 및 협력업체 정보
	async getPartnerInfo_() {
		return await api.getPartner();
	}
};
